<template>
  <div>
    <div :class="isPopUp ? 'workerPopUp' : 'worker'" v-for="item in workers" :key="item.id">
      <div class="worker__container">
        <div class="worker__avatarBlock">
          <div class="worker__avatar"><v-icon>mdi-account</v-icon></div>
        </div>
        <div class="worker__infoBlock">
          <div class="worker__info">
            <span class="worker__position">{{ item.position }} : </span>
            <span class="worker__name">{{ item.name }}</span>
          </div>
          <div class="worker__phone">{{ item.phone }}</div>
        </div>

        <div v-if="isPopUp" class="worker__checkboxBlock">
          <v-checkbox
            class="worker__checkbox"
            :value="item.id"
            v-model="formData.id"
            @change="$emit('updateCheckedItems', formData.id)"></v-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { computed } from '@vue/composition-api'
import useForm from '@/compositions/useForm'

export default ({
  props: {
    isPopUp: Boolean,
    workers: Array,
    orderWorkers: Array,
  },
  setup(props) {
    const watcher = computed(() => {
      if (props.orderWorkers) {
        const orderWorkersIds = props.orderWorkers.map(el => el.id)
        const data = ({
          id: orderWorkersIds,
        })
        return data
      }
      return null
    })

    const {
      formData,
    } = useForm({
      fields: {
        id: { default: [] },
      },
      watcher,
    })

    return {
      formData,
    }
  },
})
</script>

<style lang="scss">
.worker {
  display: flex;
  flex-direction: column;
}

.workerPopUp {
  display: flex;
  flex-direction: column;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(34, 34, 34, 0.10);
  }
}

.worker__container {
  padding: 5px 0;
  margin: 0 0 15px 0;
  font-size: 1.6rem;
  display: flex;
  justify-content: flex-start;
}

.worker__avatarBlock {
  margin: 0 10px 0 0;
}

.worker__avatar {
  padding: 6px;
  border-radius: 50%;
  background-color: rgba(34, 34, 34, 0.10);
}

.worker__infoBlock {
  width: 100%;
}

.worker__position {
  color: #222;
  font-weight: 400;
}

.worker__name {
  color: #222;
  font-weight: 500;
}

.worker__phone {
  color: #2F80ED;
  font-weight: 400;
}

.worker__checkboxBlock {
  .v-input__control {
    margin: 0 !important;
    align-self: flex-start !important;
    padding: 0 !important;
  }

  .v-input--selection-controls {
    margin: 5px 0 0 0;
    padding: 0;
  }

  .v-icon {
    border-radius: 3px;
  }
}
</style>
